import ApplicationController from './application_controller';
import log from '../lib/logger';

export default class extends ApplicationController {
  static targets = ['animationContainer'];

  connect() {
    // Initialize the animation when the controller connects
    if (this.hasAnimationContainerTarget) {
      this.initializeAnimation();
    }
  }

  animationContainerTargetConnected() {
    // This will be called when the animation container element is added to the DOM
    this.initializeAnimation();
  }

  initializeAnimation() {
    // Import and initialize the payment method history animation module
    import('../pages/payment_method_history_animation')
      .then((module) => {
        const initAnimation = module.default;
        if (initAnimation !== undefined) {
          // Get history data from the data attribute
          let historyData = [];
          try {
            const dataAttr = this.animationContainerTarget.dataset.historyData;
            if (dataAttr && dataAttr !== 'undefined') {
              historyData = JSON.parse(dataAttr);
            }
          } catch (e) {
            log.error('Error parsing history data:', e);
            historyData = [];
          }

          const { patientId } = this.animationContainerTarget.dataset;

          // Initialize the animation with the data
          initAnimation(historyData, patientId);
        }
      })
      .catch((error) => {
        log.error('Error loading payment method history animation:', error);
      });
  }

  // Action methods for controls
  play() {
    if (window.paymentMethodAnimation && window.paymentMethodAnimation.play) {
      window.paymentMethodAnimation.play();
    }
  }

  pause() {
    if (window.paymentMethodAnimation && window.paymentMethodAnimation.pause) {
      window.paymentMethodAnimation.pause();
    }
  }

  reset() {
    if (window.paymentMethodAnimation && window.paymentMethodAnimation.reset) {
      window.paymentMethodAnimation.reset();
    }
  }

  stepForward() {
    if (window.paymentMethodAnimation && window.paymentMethodAnimation.stepForward) {
      window.paymentMethodAnimation.stepForward();
    }
  }

  stepBackward() {
    if (window.paymentMethodAnimation && window.paymentMethodAnimation.stepBackward) {
      window.paymentMethodAnimation.stepBackward();
    }
  }
}
